import { gql } from "@apollo/client";

export const ResetServiceReminder = gql`
    mutation ResetServiceReminder ($id: ID!, $input: ServiceReminderResetInput!) {
        resetServiceReminder (id: $id, input: $input) {
            id
            nextDueDate
            lastServiceDate
        }
    }
`;
